import { createApp } from "vue";
//import Echo from "laravel-echo"

import App from "./App.vue";

import router from "./router.js";
import store from "./store";
import FlashMessage from '@smartweb/vue-flash-message';

//global component
import BaseTitle from '@/components/ui/BaseTitle.vue';
import BaseCard from '@/components/ui/BaseCard.vue';
import BaseBadge from '@/components/ui/BaseBadge.vue';
import BaseButton from '@/components/ui/BaseButton.vue';
import BaseButtonSm from '@/components/ui/BaseButtonSm.vue';
import BaseDialog from '@/components/ui/BaseDialog.vue';
import BaseSpinner from '@/components/ui/BaseSpinner.vue';
import MainLogo from '@/components/site/MainLogo.vue';
import BaseCheckbox from '@/components/ui/BaseCheckBox.vue';
import Copyright from '@/components/site/Copyright.vue';
import UserNameTag from '@/components/users/UserNameTag.vue';

import '@toast-ui/editor/dist/toastui-editor.css';
import 'tui-color-picker/dist/tui-color-picker.css';
import '@toast-ui/editor/dist/i18n/ko-kr';
import '@toast-ui/jquery-editor';
//pulgins
//import './plugins/editor'; 버전 안맞아서 안됨
//import './plugins/moment'; prototype 안된다 어쩌고 에러나옴
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUserSecret,faAngleUp,faAngleDown, faBars,faImage,faTimes,faCheck ,faCalendarAlt,
faExclamationCircle, faTimesCircle,faUser,faComments,faMagic,faPlay,faParking, faUserCheck, faShoppingCart, faUndoAlt,faArrowUp,
faSignOutAlt,faSignInAlt,faEye,faHeart,faPencilAlt, faAngleLeft, faPlayCircle
} from '@fortawesome/free-solid-svg-icons'
//import { http } from '@/services/http_service';
// window.Pusher = require('pusher-js');
// window.Echo = new Echo({
//     //authEndpoint: '/api/v1/auth/test',
//     broadcaster: 'pusher',
//     key: 'asdfsdfsdf',
//     wsHost: window.location.hostname,
//     wsPort: 6001,
//     forceTLS: false,
//     disableStats: true,
//     authorizer: (channel) => {
//         return {
//             authorize: (socketId, callback) => {
//                 http().post('/broadcasting/auth', {
//                     socket_id: socketId,
//                     channel_name: channel.name
//                 })
//                 .then(response => {
//                     callback(false, response.data);
//                 })
//                 .catch(error => {
//                     callback(true, error);
//                 });
//             }
//         };
//     },
// });
import CKEditor from '@ckeditor/ckeditor5-vue';

import VueCookies from 'vue3-cookies'
const app = createApp(App);
window.Kakao.init('2da26279be20c2b78c9fe6d933e20b2b');
app.use(CKEditor);
app.use(router);
app.use(store);
app.use(FlashMessage);

app.use(VueCookies, {
    expireTimes: "1d",
    path: "/",
    domain: "",
    secure: false,
    sameSite: "None"
});


library.add(faUserSecret,faAngleUp,faAngleDown, faBars,faImage, faTimes,faCheck,faCalendarAlt,
    faExclamationCircle,faTimesCircle,faUser,faComments,faMagic,faPlay,faParking,faUserCheck, faShoppingCart,faUndoAlt,faArrowUp,
    faSignOutAlt,faSignInAlt,faEye,faHeart,faPencilAlt,faAngleLeft,faPlayCircle)
app.component('font-awesome-icon', FontAwesomeIcon)
app.component('base-card', BaseCard);
app.component('base-badge', BaseBadge);
app.component('base-button', BaseButton);
app.component('base-button-sm', BaseButtonSm);
app.component('base-dialog', BaseDialog);
app.component('base-spinner', BaseSpinner);
app.component('main-logo', MainLogo);
app.component('copyright', Copyright);
app.component('user-name-tag', UserNameTag);
app.component('base-checkbox', BaseCheckbox);
app.component('base-title', BaseTitle);

app.mount("#app");
